import React, { useState } from "react";
import {
  AppBar,
  Badge,
  Button,
  Container,
  IconButton,
  InputBase,
  Toolbar,
} from "@material-ui/core";

import {
  AccountCircleOutlined,
  ExpandMore,
  Menu,
  Search,
  ShoppingBasketOutlined,
  Facebook,
  Twitter,
  Pinterest,
  YouTube,
} from "@material-ui/icons";

import MobileMenu from "./MobileMenu";
import { Link as RouterLink } from "react-router-dom";
import { useHistory } from "react-router-dom";

interface HeaderProps {
  cartCount: number;
  onCartClick: () => void;
}

const Header: React.FC<HeaderProps> = ({
  cartCount,
  onCartClick,
}) => {
  const [mobileOpen, setMobileOpen] =
    useState(false);

    const history = useHistory();

  return (
    <>
      <AppBar
        position="static"
        elevation={0}
        className="main-header"
      >
        <Container maxWidth="lg">
          {/* =========================
              TOP HEADER
          ========================= */}

          <Toolbar className="header-toolbar">
            {/* Mobile menu */}
            <IconButton
              className="mobile-menu-button"
              onClick={() => setMobileOpen(true)}
            >
              <Menu />
            </IconButton>

            {/* Logo */}
            <div className="organic-logo">
              <div className="logo-shop-icon">
                <span className="logo-shop-roof">
                  ☰
                </span>

                <span className="logo-leaf">
                  ◆
                </span>
              </div>

              <div className="logo-text">
                <div className="logo-shop">
                  Shop
                </div>

                <div className="logo-organic">
                  Organic
                </div>
              </div>
            </div>

            {/* Search */}
            <div className="header-search-wrapper">
              <div className="header-search">
                <InputBase
                  placeholder="Search..."
                  className="search-input"
                />

                <button className="category-select">
                  <span>All Categories</span>

                  <ExpandMore />
                </button>

                <button className="search-button">
                  <Search />
                </button>
              </div>
            </div>

            {/* Right actions */}
            <div className="header-actions">
              <Button
                component={RouterLink}
                to="/login"
                className="login-button"
                startIcon={
                  <AccountCircleOutlined />
                }
              >
                Login
              </Button>

              <button
                className="basket-button"
                onClick={() => history.push("/cart")}
              >
                <Badge
                  badgeContent={cartCount}
                  color="secondary"
                >
                  <ShoppingBasketOutlined />
                </Badge>

                <div className="basket-content">
                  <span className="basket-label">
                    Shopping Basket
                  </span>

                  <span className="basket-price">
                    ${"0.00"}
                  </span>
                </div>
              </button>
            </div>
          </Toolbar>

          {/* =========================
              NAVIGATION
          ========================= */}

          <div className="navigation-wrapper">
            {/* Category button */}
            <Button
              className="category-button"
              endIcon={<ExpandMore />}
            >
              SHOP BY CATEGORY
            </Button>

            {/* Main navigation */}
            <div className="nav-links">
              <Button style={{fontSize:'12px',fontFamily:'Nunito',textTransform:'none'}} component={RouterLink}
                  to="/">Home</Button>
              <Button style={{fontSize:'12px',fontFamily:'Nunito',textTransform:'none'}} component={RouterLink}
                  to="/shop">Shop</Button>
              <Button style={{fontSize:'12px',fontFamily:'Nunito',textTransform:'none'}} component={RouterLink}
                  to="/about">About</Button>
              <Button style={{fontSize:'12px',fontFamily:'Nunito',textTransform:'none'}} component={RouterLink}
                  to="/contact">Contact</Button>
            </div>

            {/* Social icons */}
            <div className="social-links">
              <IconButton>
                <Facebook />
              </IconButton>

              <IconButton>
                <Twitter />
              </IconButton>

              <IconButton>
                <Pinterest />
              </IconButton>

              <IconButton>
                <YouTube />
              </IconButton>
            </div>
          </div>
        </Container>
      </AppBar>

      <MobileMenu
        open={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />
    </>
  );
};

export default Header;